<template>
  <div
    role="button"
    class="bg-background-neutral-secondary mt-2 flex items-center space-x-4 rounded-2xl px-4 py-3"
    @click="emit('onInputClick')"
  >
    <div class="w-full">
      <p class="text-text-neutral-quaternary text-xs">
        {{ $t('general.passengers') }}
      </p>
      <p
        class="text-text-neutral-primary text-base font-semibold"
      >
        {{ passengersAmountText }}, {{ cabinClassText }}
      </p>
    </div>
    <PersonIcon class="text-text-positive-primary h-6 w-6 shrink-0" />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { passengersTextModel } from 'shared';
  import type { CabinClass, Passengers } from 'shared';

  import PersonIcon from '@/assets/images/person-icon.svg?component';

  const emit = defineEmits<{
    (e: 'onInputClick'): void;
  }>();

  const props = defineProps<{
    isYouth: boolean;
    passengers: Passengers;
    cabinClass: CabinClass;
    source: string;
  }>();

  const passengersText = passengersTextModel.usePassengersText();

  const passengersAmountText = computed(() =>
    passengersText.getPassengersAmountText(props.passengers, props.isYouth),
  );

  const cabinClassText = computed(() =>
    passengersText.getCabinClassText(props.cabinClass, props.isYouth),
  );
</script>
